import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentProfileQuickInfo extends Layout {
    buttonPartialShipmentProfileCode: Button;
    panelPartialShipmentProfileQuickInfo: Panel;
    sourceManifestProfile: DataSource;
    textboxDescr: Textbox;
    textboxPartialShipmentProfileId: Textbox;
}
